import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, FormattedHTMLMessage, injectIntl, intlShape } from 'react-intl';
import './TermsPage.less';
import OneColumnLayout from '../../../../framework/components/Templates/OneColumnLayout/OneColumnLayout';
import BodyHeader from '../../../../shared-components/BodyHeader/BodyHeader';
import TermsPageForm from './TermsPageForm/TermsPageForm';
import ApproveMessage from '../../../components/ApproveMessage/ApproveMessage';


export class TermsPage extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
    };
    static defaultProps = {
        onComponentDidMount: () => {}
    };

    render() {
        const { intl } = this.props;
        return (
            <OneColumnLayout pageName="TermsPage">
                <div className="termHeader">
                    <BodyHeader />
                    <ApproveMessage intl={intl} />
                </div>
                <TermsPageForm />
            </OneColumnLayout>
        );
    }
}

export const mapStateToProps = state => ({
});


export const mapDispatchToProps = dispatch => ({
    onComponentDidMount() {
    },
    onClickContinue() {

    },
    submitCallback(formValues, applicationType) {
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(TermsPage));
